import React from "react";
import { LoaderCircle } from "lucide-react"; // Import LoadingIcon từ lucid-react

const LoadingLeftBot = () => {
  return (
    <div className="fixed flex items-center bottom-0 right-0 m-4">
      <LoaderCircle
        className="animate-spin text-blue-600"
        width={30}
        height={30}
      />
    </div>
  );
};

export default LoadingLeftBot;
